import HomepageSections from './homepage-sections';
import Seo from '@/components/seo';
export default function LandingPage() {
 return <><Seo title="서울 앱·웹·SI 개발사" description="미스터디벨로는 서울 마포구의 앱·웹 개발사입니다. 개인사업자·스타트업·기업의 기획·디자인·개발·QA, MVP와 SI 개발 범위를 상담합니다. 실제 사례와 정부지원사업 개발 준비·견적·유지보수 안내를 확인하세요." path="/" /><HomepageSections /></>;
}
